<template>
    <div class='apply-sub-success'>
      <div class="shopImg">
        <img :src="img" alt="" width="92" height="92" style="margin: 14px 0 9px 0px;">
        <p>申请提交成功！</p>
      </div>
      <div  class="succMess">
        <div class="succTitle">
            <p class="titleMess">中奖通知会通过微信服务提醒或短信通知您。</p>
            <p class="titleMessEnd">活动结束后可在0元试用首页 - 我的试用 - 已中奖中关注自己是否中奖。</p>
        </div>
      </div>
      <div class="apply-btn">
      <button @click="goTrialList">查看更多</button>
    </div>
    </div>
  </template>
  
  <script>

  import {BuiedPointClick_Fn} from "@assets/js/BuriedPointEvent";
  export default {
    components: {},
    data() {
      return {
        img: this.$route.query.img ? this.$route.query.img : ''
      }
    },
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        goTrialList() {
          BuiedPointClick_Fn("xmhh5_Freetrial_click", {
            xmhh5_Freetrial_pageclick:'查看更多'
          });
          if (window.history.length > 3) {
            this.$router.go(-3);
          } else {
            this.$router.replace({ path: "/trialProducts" });
          }
        }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() { },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
  }
  </script>
  <style lang='less' scoped>
  // @import url(); 引入公共css类
  .apply-sub-success {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    background: #fff;
    .shopImg{
        text-align: center;
        p {
            font-size: 15px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 21px;
        }
    }
    .succMess{
      height: 84px;
      width: 351px;
      margin: 20px 12px 0px;
      border-radius: 8px;
      background: #F7F7F7;
      .succTitle{
        text-align: center;
        margin: 12px 14px;
        .titleMess{
          font-family: PingFang-SC-Medium, PingFang-SC;
        }
        .titleMessEnd{
          font-family: PingFang-SC-Medium, PingFang-SC;
        }
        p{
            font-size: 14px;
            font-weight: 500;
            color: #666666;
            line-height: 20px;
        }
      }
    }
    .apply-btn {
        width: 100%;
        height: 65px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        bottom: 0;

        button {
        width: 351px;
        height: 45px;
        background: #FC656F;
        border-radius: 25px;
        border-style: none;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        }
    }
  }
  
  /deep/ .van-cell {
    height: 100%;
    border-radius: 8px;
    background: #f7f7f7;
  }
  </style>